/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Descriptionmustbeatleast10characters5Inputs */

const en_descriptionmustbeatleast10characters5 = /** @type {(inputs: Descriptionmustbeatleast10characters5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description must be at least 10 characters`)
};

const de_descriptionmustbeatleast10characters5 = /** @type {(inputs: Descriptionmustbeatleast10characters5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung muss mindestens 10 Zeichen lang sein`)
};

/**
* | output |
* | --- |
* | "Description must be at least 10 characters" |
*
* @param {Descriptionmustbeatleast10characters5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const descriptionmustbeatleast10characters5 = /** @type {((inputs?: Descriptionmustbeatleast10characters5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Descriptionmustbeatleast10characters5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_descriptionmustbeatleast10characters5(inputs)
	return de_descriptionmustbeatleast10characters5(inputs)
});
export { descriptionmustbeatleast10characters5 as "descriptionMustBeAtLeast10Characters" }